import productUtils from '@/core/productUtils'
import { GetProjectInfo, PlacePublicComponent, RecordJournal } from '@/core/gcsUtils'
import { localCachePath, checkExistFile } from '@/core/desktopCache'
export default {
  methods: {
    /**
     * G 构件布置
     * 1. 根据设计值、运行值，获取产品写入的参数及值
     * 2. 添加到项目库得到项目构件信息，调用G插件布置接口，并埋点
     * @param payload Object, 调用获取产品写入参数所需要的入参
     * @param trackPartParams Object, 埋点时，需要调用方传入的信息，目前为{g_c_product_id, g_c_source}
     * @param recordMethodName String, 如果需要录制，录制的事件名必传
     */
    async placeGcsComponent({ payload, trackPartParams = {}, recordMethodName }) {
      try {
        // 获取产品写入的参数
        const productPlaceInfo = await this.$api.products.getProductParams(payload)
        const publicComponentInfo = {
          id: String(productPlaceInfo.publicComponentId),
          digitalComponentId: String(payload.digitalComponentId),
          name: productPlaceInfo.componentName,
          suffix: productPlaceInfo.suffix,
          categoryNames: productPlaceInfo.softwareCategoryNames ? productPlaceInfo.softwareCategoryNames.split('_') : [],
          thumbnail: productPlaceInfo.thumbnail,
          instanceParameters: productPlaceInfo.parameterValues
        }
        const familyType = productPlaceInfo.familyTypeName
        if (familyType) {
          if (recordMethodName) {
            RecordJournal(recordMethodName, { publicComponent: publicComponentInfo, familyTypeToBePlaced: familyType })
          }
          const { data: isSuccess } = await PlacePublicComponent(publicComponentInfo, familyType)
          if (isSuccess) {
            // 布置成功
            const { data } = await GetProjectInfo()
            this.$tracks({
              event: 'shopComponentPlace',
              params: {
                ...trackPartParams,
                g_c_component_id: productPlaceInfo.publicComponentId,
                g_c_component_name: productPlaceInfo.componentName,
                g_c_project_id: data && data.id,
                g_c_project_file_path: data && data.path,
                g_c_project_file_name: data && data.name
              }
            })
          }
        } else {
          this.$message.error('布置失败')
        }
      } catch (err) {
        if (err.code === 'invalid.related.components') {
          this.$confirm('暂无可用资源，我们将联系厂商尽快提供，请通过“反馈”或“广小二”联系官方客服。', '布置失败', {
            type: 'warning',
            showCancelButton: false,
          }).then().catch()
        } else {
          this.$message.error('布置失败')
        }
      }
    },
    /**
     * R 构件布置
     * 1. 获取产品写入的参数及值
     * 2. 添加到项目库得到项目构件信息，调用R插件布置接口，并埋点
     * @param payload Object, 调用获取产品写入参数所需要的入参
     * @param [designValues] [{}], 设计值信息，已选产品列表页的布置可以不传
     * @param trackPartParams Object, 埋点时，需要调用方传入的信息，目前为{g_c_product_id, g_c_source}
     */
    async placeRevitComponent({ payload, designValues, trackPartParams = {}}) {
      try {
        // 获取产品布置所需要的信息
        const productInfo = await this.$api.products.getArrangementInfo(payload)
        const designProperties = designValues || productInfo.shareParamValues || []
        const sharedParameters = productUtils.handleShareDefinitionsValue(this.shareDefinitions, designProperties)
        const placePayload = {
          publicComponentId: String(productInfo.publicComponentId),
          publicComponentVersion: productInfo.softwareVersion,
          publicComponentName: productInfo.componentName,
          familyTypeToBePlaced: productInfo.familyTypeName,
          sharedParameters
        }
        const { code } = await this.$revitClient.PlaceProductComponent(placePayload)
        if (code === 'success') {
          // 布置成功
          const res = await this.$revitClient.GetProjectInfo()
          const { id, name, path } = res.data || {}
          this.$tracks({
            event: 'shopComponentPlace',
            params: {
              ...trackPartParams,
              g_c_component_id: productInfo.publicComponentId,
              g_c_component_name: productInfo.componentName,
              g_c_project_id: id,
              g_c_project_file_name: name,
              g_c_project_file_path: path,
            }
          })
        }
      } catch (err) {
        if (err.code === 'invalid.related.components') {
          this.$confirm('暂无可用资源，我们将联系厂商尽快提供，请通过“反馈”或“广小二”联系官方客服。', '布置失败', {
            type: 'warning',
            showCancelButton: false,
          }).then().catch()
        } else {
          this.$message.error('布置失败')
        }
      }
    },
    beforeDownload(id, name, suffix) {
      const catchPath = localCachePath()
      this.saveAsPath = `${catchPath}\\${id}\\${name}.${suffix}`
      return checkExistFile(this.saveAsPath)
    },
    /**
     * CS 构件布置
     * 1. 获取产品写入的参数及值
     * 2. 添加到项目库得到项目构件信息，调用R插件布置接口，并埋点
     * @param payload Object, 调用获取产品写入参数所需要的入参
     * @param [designValues] [{}], 设计值信息，已选产品列表页的布置可以不传
     * @param trackPartParams Object, 埋点时，需要调用方传入的信息，目前为{g_c_product_id, g_c_source}
     */
    async placeCSComponent(component) {
      try {
        const login = await this.checkLogin()
        if (login) {
          const { familyTypes } = await this.$api.gcsComponent.detail(component.softwareCode, component.id, this.softwareVersion)
          let familyTypeNames = []
          if (familyTypes && familyTypes.length) {
            familyTypeNames = familyTypes.map((m) => m.name)
          }
          if (!this.beforeDownload(component.id, component.name, component.suffix)) {
            const params = {
              userId: this.userId,
              softwareVersionId: component.id,
              dataVersionId: null,
              name: component.name,
              suffix: component.suffix,
              typeNameToBePlaced: null, // 要布置的族类型名称
              loadAllTypes: true, // 是否载入所有族类型
              typeNames: familyTypeNames, // 所有族类型名称列表
            }
            await this.$desktopClient.PlaceComponent(params)
            this.$fullLoading.close()
            return
          }
          await this.$api.download.novaDownloadUrl(this.softwareCode, component.id, { productId: component.productId, software_version: this.softwareVersion }).then(async(res) => {
            if (res) {
              try {
                await this.$desktopClient.DownloadFile(res, this.saveAsPath, true).then(async() => {
                  const params = {
                    userId: this.userId,
                    softwareVersionId: component.id,
                    dataVersionId: null,
                    name: component.name,
                    suffix: component.suffix,
                    filePath: this.saveAsPath,
                    typeNameToBePlaced: '', // 要布置的族类型名称
                    loadAllTypes: true, // 是否载入所有族类型
                    typeNames: familyTypeNames, // 所有族类型名称列表
                  }
                  await this.$desktopClient.PlaceComponent(params)
                })
              } catch (err) {
                console.log(err)
                this.$message.error('下载失败')
              }
            }
          })
        }
      } catch (error) {
        this.$message.error('布置失败')
      }
    },
  },
}
